import axios from "axios";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import traslateMixin from '~/mixins/traslate.js';
import baseMixin from '~/mixins/base.js';
import store from "~/store";
export default {
    middleware: ["auth", "page"],
    mixins: [
        traslateMixin,
        baseMixin
    ],
    data() {
        return {
            input_horizontal: {
                label: 'col-sm-2',
                input: 'col-sm-10'
            },
            default_horizontal: {
                label: 'col-sm-2',
                input: 'col-sm-10'
            },
            page_loaded: false,
            load_boundaries: {
                sides: ['top', 'rigth'],
                query: '.main-card-body'

            },
            page: {
                _loading: true,
            }

        }
    },
    metaInfo() {
        return { title: this.$t(this.$route.name) };
    },
    messages: {
        create: {
            header: "¡_save!",
            body: "saved_successfully",
            color: 'success',
        },
        update: {
            header: "¡_update!",
            body: "changes_have_been_saved_successfully",
            color: 'success',
        },
        delete: {
            header: "¡_delete!",
            body: "successfully_removed",
            color: 'success',
        },
        error: {
            header: '¡_error!',
            body: "there_was_a_problem",
            color: 'danger'
        },
        success: {
            header: "¡_success!",
            body: "action_completed_successfully",
            color: "success",
        },
    },

    computed: {
        title_page: function () {
            return this.$t(this.$route.name);
        },
        titlePage: function () {
            return this.$route.meta.title
                ? this.$route.meta.title
                : this.$route.name;
        },
        view_type: function () {
            return this.$route.query.view_type;
        },
        method_type: function () {
            let method = "POST";
            if (this.$route.query.view_type == "edit") {
                method = "PUT";
            }
            return method;
        },
        routeName() {
            return this.$route.name;
        },

        ...mapGetters({
            storePageTables: "page/tables",
            storePageLoading: "page/loading",
            storePageFilters: "page/filters",
            storeGlobalLanguages: "global/languages",
            storeGlobalCountries: "global/countries",
            storeCancelToken: "global/requestCancelToken"
        })
    },
    watch: {
        storePageFilters: {
            handler(newValue, oldValue) {
                // this.updateData();
            },
            deep: true
        }
    },
    methods: {
        /**
         * 
         * @param {*} fieldName field name to validate.
         * @description Check if a field defined in the vue validates option is valid.
         * **Important.-  This funcion work together with module vuelidate.
         */
        checkIfValid(fieldName) {
            const field = this.$v.form[fieldName];

            if (!field.$dirty) {
                return null
            }
            return !(field.$invalid || field.$model === '')
        },
        /**
         * 
         * @param {*} fieldName field name to validate.
         * @description Check if a field defined in the vue validates option is valid.
         * **Important.-  This funcion work together with module vuelidate.
         */
        checkIfFormValid({ form_name, field_name }) {
            const field = this.$v.forms[form_name][field_name];
            if (!field.$dirty) {
                return null
            }
            return !(field.$invalid || field.$model === '')
        },

        checkIfFormTableValid({ table_name, index, field_name }) {

            let field = this.$v.tables[table_name].items.$each[index][field_name];
            if (!field.$dirty) {
                return null
            }
            return !(field.$invalid || field.$model === '')
        },

        checkIfFormTableIsValid({ tableName }) {

            let table = this.$v.tables[tableName];
            if (!table.$dirty) {
                return null
            }
            return !(table.$invalid || table.$model === '')
        },

        checkPagePromiseContinue() {
            return this.$options.name != store.getters["page/name"];
        },

        openModal({ modal_name, data = {} }) {
            let modal = this.modals[modal_name];
            if (!modal) {
                throw { code: 422, message: this.$t("Modal does not exist") };
            }
            for (const key in modal.data) {
                if (Object.hasOwnProperty.call(modal.data, key) && Object.hasOwnProperty.call(data, key)) {
                    modal.data[key] = data[key];
                }
            }
            this.modals[modal_name].show = !this.modals[modal_name].show;
        },

        async showMessageError(error) {

            let message = this.$options.messages.error;
            let header = message.header;
            let body = message.body;

            if (error) {
                if (error.response && error.response.data && error.response.data.error) {
                    body = error.response.data.error;

                } else if (error.response && error.response.data && error.response.data.message) {
                    body = error.response.data.message;

                } else if (error.message) {
                    body = error.message;

                } else {
                    body = error;
                }

                this.$store.dispatch('toast/addFixedToasts', {
                    ...message,
                    header,
                    body,
                });
                // console.error(error);
            }


        },
        async updateData() {
            this.updatePageLoading(false);
        },
        async showMessageByMethod(method) {
            switch (method) {
                case "PUT":
                    this.$store.dispatch('toast/addFixedToasts', {
                        ...this.$options.messages.update
                    });
                    break;
                case "POST":
                    this.$store.dispatch('toast/addFixedToasts', {
                        ...this.$options.messages.create
                    });
                    break;
                default:
                    break;
            }
        },
        createQuery({ from, to, order = "asc", query_fields = {}, columnFilterValue = {} }) {
            let query = {
                where: {
                    ...query_fields,
                    created_at: {
                        between: [from, to, false]
                    }
                },
                order: {
                    created_at: order
                }
            }

            // Add page filter to query
            // query.where = {
            //     ...query.where,
            //     ...this.storePageFilters.where
            // }


            for (const key in columnFilterValue) {
                if (columnFilterValue[key] !== '') {
                    query.where[key] = {
                        like: `%${columnFilterValue[key]}%`
                    }
                }

            }

            if (!from || !to) {
                delete query.where.created_at
            }
            if (!order) {
                delete query.order
            }
            return query;

        },

        normalizeObject(object) {
            for (const key in object) {
                if (Object.hasOwnProperty.call(object, key)) {
                    const item = object[key];
                    if (item == null || item == undefined) {
                        object = {
                            ...object,
                            [key]: ""
                        }
                    }

                }
            }

            return object;
        },

        normalizeArrayData({ data }) {
            if (Array.isArray(data)) {
                return data.map((item) => {
                    return this.normalizeObject(item);
                });
            } else {
                return [];
            }
        },

        addFieldToTable({ tableName, fieldName, value }) {
            let table = this.tables[tableName];
            let itemsTable = [...table.items];

            itemsTable = itemsTable.map((item) => {
                item[fieldName] = value;
            });
        },


        /**
         * !IMPORTANT To dismiss 
         */

        loadTable({ table_name, data, extra_fields = [] }) {

            /* alert("¡This funtions not supported!")
            return; */
            data = [...data];
            if (Array.isArray(data)) {

                this.tables[table_name].items = data.map((item, index) => {

                    let fields = this.tables[table_name].fields;
                    let formatted_item = {};
                    for (let i = 0; i < fields.length; i++) {
                        const field = fields[i];

                        switch (field.key) {
                            case 'id':
                                let id = (field.alternative_key) ? item[field.alternative_key] : item[field.key];
                                if (!id) id = index;
                                formatted_item = {
                                    ...formatted_item,
                                    id
                                }
                                break;
                            default:
                                formatted_item = {
                                    ...formatted_item,
                                    [field.key]: (field.alternative_key) ? item[field.alternative_key] : item[field.key]
                                }
                                break;
                        }
                    }
                    for (let i = 0; i < extra_fields.length; i++) {
                        const extra_field = extra_fields[i];
                        if (extra_field.label && extra_field.name) {
                            formatted_item = {
                                ...formatted_item,
                                [extra_field.label]: item[extra_field.name]
                            }
                        } else {
                            formatted_item = {
                                ...formatted_item,
                                [extra_field]: item[extra_field]
                            }
                        }

                    }
                    for (const key in formatted_item) {
                        if (Object.hasOwnProperty.call(formatted_item, key)) {
                            const item = formatted_item[key];
                            if (item == null || item == undefined) {
                                formatted_item = {
                                    ...formatted_item,
                                    [key]: ""
                                }
                            }

                        }
                    }

                    return formatted_item;
                });
            } else {
                this.tables[table_name].items = [];
            }

        },

        async formatDataTable({ table_name, data }) {
            return data;
        },

        checkStoreConfig() {
            for (let i = 0; i < this.storePageTables.length; i++) {
                const storageTableConfig = this.storePageTables[i];


                for (const tableName in this.tables) {
                    if (storageTableConfig.name == tableName) {
                        this.tables[tableName].rows = storageTableConfig.limit;
                        this.tables[tableName].page = storageTableConfig.page;
                        this.tables[tableName].order = storageTableConfig.order;
                        this.tables[tableName].columnFilterValue = storageTableConfig.columnFilterValue;

                        this.checkStoreTableFieldsConfig({
                            tableName
                        });
                    }

                }
            }


        },

        checkStoreTableFieldsConfig({ tableName }) {

            let findStoreTableConfig = this.storePageTables.find(table => table.name == tableName);

            let tableFileds = [];
            if (findStoreTableConfig) {
                let storeTableActiveFields = findStoreTableConfig.allFields.filter(field => field.active);
                for (let i = 0; i < storeTableActiveFields.length; i++) {
                    let storeTableActiveFiled = storeTableActiveFields[i];
                    let fieldCurrentConfig = this.tables[tableName].fields.find(field => field.key == storeTableActiveFiled.key);

                    if (fieldCurrentConfig) {
                        tableFileds.push({
                            ...fieldCurrentConfig,
                            ...storeTableActiveFields

                        });
                    } else {
                        tableFileds.push({
                            ...storeTableActiveFiled
                        });
                    }
                }
            }

        },

        hasItemsInTable({ tableName }) {
            let findTable = this.storePageTables.find(table => table.name == tableName);
            if (findTable)
                return findTable.hasItems;
            return true;
        },

        getDefaultTable() {
            let table = this.table;
            if (!table) {
                // Get first element of object
                for (const key in this.tables) {
                    if (Object.hasOwnProperty.call(this.tables, key)) {
                        table = this.tables[key];
                        break;
                    }
                }
            }

            return table;
        },

        async updateTable({ table_name, customFields, url, url_param, method = 'GET', formatQuery, formatData, filter_active = true }) {

            let from = this.from;
            let to = this.to;
            let rows = this.tables[table_name].rows;
            let page = this.tables[table_name].page;
            let order = this.tables[table_name].order;
            let columnFilterValue = this.tables[table_name].columnFilterValue;
            let query;

            if (!url && this.tables[table_name].url) {
                url = this.tables[table_name].url;
            }
            if (filter_active) {
                query = await this.createQuery({
                    from,
                    to,
                    order,
                    columnFilterValue
                });
            }

            if (formatQuery) {
                query = await formatQuery(query);
            }

            this.tables[table_name].loading = true;
            //Peticion ala api
            let table_data = await this.loadData({
                url,
                url_param,
                method,
                rows,
                page,
                query
            });

            if (formatData) {
                table_data = await formatData(table_data);
            }


            let fieldNameResponseItems = this.tables[table_name]._fieldNameResponseItems || '_items';

            this.tables[table_name].total_pages = table_data.total_pages; // Set new total pages


            if (customFields) {
                // Add custom fields to table data
                table_data[fieldNameResponseItems] = table_data[fieldNameResponseItems].map((item, index) => {
                    return {
                        ...item,
                        ...customFields
                    }
                });
            }
            this.tables[table_name].items = this.normalizeArrayData({
                data: table_data[fieldNameResponseItems]
            });

            let headers = [];

            if (table_data[fieldNameResponseItems][0]) {
                for (const key in table_data[fieldNameResponseItems][0]) {
                    headers.push(key);
                }
            }
            this.tables[table_name].loading = false;
            this.$store.dispatch('page/updateTables', {
                ...this.tables[table_name],
                name: table_name,
                allFields: headers,
            });

        },

        loadLanguageInTable({ tableName, fielLanguageName = "languageName" }) {
            let table = this.tables[tableName];
            let languages = this.storeGlobalLanguages;
            if (Array.isArray(languages)) {
                for (let i = 0; i < table.items.length; i++) {
                    let languageFind = languages.find(lang => lang.id == table.items[i].language_id);
                    if (languageFind) {
                        table.items[i][fielLanguageName] = languageFind.name;
                    }
                }

                this.tables[tableName].items = table.items;
            }

        },

        loadCountryInTable({ tableName, fielCountryName = "countryName" }) {
            let table = this.tables[tableName];
            let countries = this.storeGlobalCountries;
            if (Array.isArray(countries)) {
                for (let i = 0; i < table.items.length; i++) {
                    let countryFind = countries.find(country => country.id == table.items[i].country_id);
                    if (countryFind) {
                        table.items[i][fielCountryName] = countryFind.name;
                    }
                }

                this.tables[tableName].items = table.items;
            }

        },

        filterByCountry({ tableName }) {
            let table = this.tables[tableName];
            let countryName = table.columnFilterValue.countryName;

            if (countryName) {
                table.columnFilterValue.country_id = this.getCountryId({ countryName });
            } else {
                delete table.columnFilterValue.country_id;
            }

            this.tables[tableName].columnFilterValue = table.columnFilterValue;
        },

        getCountryId({ countryName }) {
            let countries = this.storeGlobalCountries;
            let countryTofind = countryName.toLowerCase();
            let countryFind = countries.find(country => country.name.toLowerCase().includes(countryTofind));

            if (countryFind) {
                return countryFind.id;
            }
        },

        /**
         * 
         * @param {*} chart_name  
         */

        loadChart({ chart_name, labels_dataset = [], chart_data = [], field_chart_data, filed_chart_label, colors = [] }) {
            let labels = [];
            this.charts[chart_name].datasets = [];
            for (let i = 0; i < chart_data.length; i++) {
                let data = chart_data[i];
                if (data._items) {
                    data = data._items;
                }
                const color = colors[Math.floor(Math.random() * data.length)];
                const label_dataset = labels_dataset[i];
                let dataset = {
                    label: label_dataset, // Se especifica el nombre de la base de datos del dato representado.
                    hoverBackgroundColor: '#2e59d9',
                    backgroundColor: 'transparent',
                    borderColor: color, // Se especifica el color del dato a representar.
                    data: data.map((item) => item[field_chart_data]), // Se especifica el valor del dato representado.
                    fill: true,
                }

                labels = data.map((item) => item[filed_chart_label]);

                this.charts[chart_name].labels = labels;
                this.charts[chart_name].datasets.push(dataset);

            }
            this.charts[chart_name].loading = false;
        },

        async loadForm({ form_name, data }) {
            let form = this.forms[form_name];
            if (!form) {
                throw { code: 422, message: this.$t("the_form_does_not_exist") };
            }
            for (const key in form) {
                if (Object.hasOwnProperty.call(form, key) && Object.hasOwnProperty.call(data, key)) {
                    form[key] = data[key];
                }
            }

            this.forms = {
                ...this.forms,
                [form_name]: form
            }
        },

        async updateFormDefault({ form_name, url, url_param }) {
            if (this.view_type && this.view_type == "edit") {
                let form_data = await this.loadData({
                    url,
                    url_param
                });
                await this.loadForm({
                    form_name,
                    data: form_data
                });
            }
        },

        async formParseData({ data }) {
            return data;
        },

        async updateForm({ form_name, url, url_param, formatData = null }) {
            if (this.view_type && this.view_type == "edit") {
                let form = this.forms[form_name];
                form._loading = true;
                let form_data = await this.loadData({
                    url,
                    url_param
                });
                if (formatData) {
                    form_data = await formatData(form_data);
                }


                form_data = await this.formParseData({
                    data: form_data
                });

                await this.loadForm({
                    form_name,
                    data: form_data
                });

                if (this.eventAfterLoadForm)
                    this.forms[form_name] = await this.eventAfterLoadForm(this.forms[form_name]);

                form._loading = false;
            }
        },

        async loadData({ url, url_param, method = 'GET', query, rows, page }) {

            let params = {
                query,
                rows,
                page
            }

            let formatted_url = (!url_param) ? url : `${url}/${url_param}`;

            for (const key in params) {
                if (Object.hasOwnProperty.call(params, key)) {
                    if (!params[key] || params[key] == "") {
                        delete params[key];
                    }
                }
            }

            let axios_config = {
                url: formatted_url,
                method,
                params
            }

            try {
                // const { data } = await axios.get(formatted_url, { params });
                const { data } = await axios(axios_config);
                return data;
            } catch (error) {
                throw error;
            }
        },

        /*
            Object params = { url_param, query, rows, page }
        */
        async loadListData({ url, list_params }) {
            let list_data = [];
            try {
                for (let i = 0; i < list_params.length; i++) {
                    const params = list_params[i];

                    let data = await this.loadData({
                        url,
                        ...params
                    })

                    list_data.push(data);
                }

                return list_data;

            } catch (error) {
                console.log(error);
                throw error;
            }

        },


        /* Replace for loadData */
        async loadFormData({ url, param_id }) {
            try {
                const { data } = await axios.get(`${url}/${param_id}`);
                return data;
            } catch (e) {
                console.log(e);
            }

        },
        async sendData({ data, url, method, url_param }) {

            let format_url = (!url_param) ? url : url + "/" + url_param

            let axios_config = {
                url: format_url,
                method,
                data
            }

            try {
                const response = await axios(axios_config);
                return response.data;
            } catch (error) {
                console.log(error);
                throw error;
            }
        },

        async eventBeforeSendForm(form) {
            return form;
        },

        async eventAfterLoadForm(form) {
            return form;
        },

        /**
         * In this event you can validate your form before send it.
         * @param {String} formName 
         * @returns boolean
         */
        async eventValidateForm(formName) {
            let isValid = true;
            let formValidation = (formName) ? this.$v.forms[formName] : this.$v.form;
            formValidation.$touch();
            if (formValidation.$invalid) {
                this.showMessageError("invalid_data");
                isValid = false;
            }
            return isValid;
        },

        async sendForm({ form_name, url, url_param, method, next_page, formatData, custom_message }) {
            let form = (form_name) ? this.forms[form_name] : this.form;

            try {

                form._loading = true;

                let formData = {
                    ...form
                };


                /** If is form inValid not send */
                let isValid = await this.eventValidateForm(form_name);
                if (!isValid) {
                    form._loading = false;
                    return {
                        status: false
                    }
                }

                if (!method && method != 'PUT' && method != 'POST') {
                    method = (url_param) ? 'PUT' : 'POST';
                }



                delete formData._loading;
                if (formatData) {
                    formData = await formatData(formData);
                }

                if (this.eventBeforeSendForm) {
                    formData = await this.eventBeforeSendForm(formData);
                }
                let data = await this.sendData({
                    data: formData,
                    url,
                    url_param,
                    method
                });

                if (custom_message) {
                    this.$store.dispatch('toast/addFixedToasts', {
                        ...custom_message
                    });
                } else if (method == 'PUT') {
                    this.$store.dispatch('toast/addFixedToasts', {
                        ...this.$options.messages.update
                    });
                } else {
                    this.$store.dispatch('toast/addFixedToasts', {
                        ...this.$options.messages.create
                    });
                }

                form._loading = false;
                if (next_page)
                    this.$router.push({ name: next_page });

                return {
                    status: true,
                    data
                }

            } catch (error) {
                this.showMessageError(error);
                form._loading = false;
                throw error;
            }


        },


        async deleteData({ url, url_param, callback }) {

            let message_delete = this.$options.messages.delete;

            try {
                let result = await Swal.fire({
                    title: this.$t('are_you_sure?'),
                    text: this.$t("you_will_not_be_able_to_revert_this!"),
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: this.$t('yes,_delete_it!')
                })
                if (result.isConfirmed) {

                    let formatted_url = (!url_param) ? url : `${url}/${url_param}`;

                    let axios_config = {
                        url: formatted_url,
                        method: 'delete'
                    }
                    const { data } = await axios(axios_config);

                    if (callback)
                        callback();

                    this.$store.dispatch('toast/addFixedToasts', {
                        ...message_delete,
                    });

                    return {
                        status: true,
                        data
                    };
                }

            } catch (error) {
                this.showMessageError(error);
                /* throw error; */
                return {
                    status: false,
                };
            }
        },

        updatePageLoading(value) {
            this.$store.dispatch('page/updateLoading', {
                loading: value,
            });
        },

        /* To dismiss */
        async loadChartData({ url, list_data, chart_query_name, from, to, order = "asc" }) {

            let chart_data = [];
            try {
                for (let i = 0; i < list_data.length; i++) {
                    const element = list_data[i];
                    let query = {
                        where: {
                            [chart_query_name]: {
                                uuid: element.uuid
                            },
                            created_at: {
                                between: [from, to]
                            }
                        },
                        order: {
                            created_at: order
                        }
                    };
                    const { data } = await axios.get(url, { params: { query } });
                    chart_data.push(data);
                }
                return chart_data;
            } catch (error) {
                console.log(error);
                throw error
            }
        },

        async loadLanguages() {
            let data = [];
            if (this.storeGlobalLanguages.length <= 0) {
                let response = await axios.get('/language');
                data = response.data;
                this.$store.dispatch("global/saveLanguages", { languages: data });
            }
        },

        async loadCountries() {
            let data = [];
            if (this.storeGlobalCountries.length <= 0) {
                let response = await axios.get('/country');
                data = response.data;
                this.$store.dispatch("global/saveCountries", { countries: data });
            }
        }



    },
    async mounted() {
        this.$store.dispatch("page/setName", { name: this.$options.name });
        this.checkStoreConfig();
        // this.loadLanguages();
        // this.loadCountries();
    },
}